import { Platform, View } from 'react-native';
import React, { useLayoutEffect } from 'react';
import { Button, Text } from '~/components';
import SuccessSVG from '~/assets/svgs/success.svg';
import { twMerge } from 'tailwind-merge';
import useAppNavigation from '~/hooks/useAppNavigation';

const InformationSent = () => {
  const { push, setOptions } = useAppNavigation();

  useLayoutEffect(() => {
    setOptions({
      headerShown: false,
    });
  }, [setOptions]);

  return (
    <View className="flex-1 items-center justify-center">
      <SuccessSVG />

      <Text className="text-center text-xl w-[250px] mt-8 mb-4">
        Agradecemos o envio das informações!
      </Text>

      <Text className="text-center text-sm text-gray-600 mx-8">
        Quando seu seguro estiver próximo do vencimento entraremos em contato
        para oferecer uma oferta especial
      </Text>

      <View
        className={twMerge(
          'absolute bottom-0 w-full px-6 py-4 border-t border-t-gray-100',
          Platform.OS !== 'web' ? 'mb-2' : ''
        )}
      >
        <Button onPress={() => push('MarisaServicos_Home')}>Fechar</Button>
      </View>
    </View>
  );
};

export default InformationSent;
